//--------------------------------------------------------------------//
//******************** emailProvidersTable *******************************//
//--------------------------------------------------------------------//
// Renders the email providers listing table. Clicking a row opens the
// parent controller's provider detail popup (via the onOpen callback - see
// emailSettingsCtrl's openProviderDetail). Delete action shows a
// confirmation dialog. Mirrors sipTrunksTable.directive.js.
import './provider-info/providerInfo.tab.js';
import './provider-accounts/providerAccounts.tab.js';
import './provider-accounts/signatureMonacoEditor.directive.js';

angular.module('emailSettingsModule')

.directive('emailProvidersTable', ['GhDialog', 'EmailSettingsService', function (GhDialog, EmailSettingsService) {
    return {
        restrict: 'E',
        scope: {
            providers: '=',
            onOpen: '&'
        },

        controller: ['$scope', 'localizationService', function ($scope, localizationService) {
            const dictionary = localizationService.getDictionary('account_settings');
            $scope.translate = (word) => localizationService.translate(word, dictionary);

            // Shared by this table's Type column and providerInfo.tab.js's
            // own Type row - kept in sync manually (no shared constant
            // module exists yet for the 3 provider types).
            $scope.providerTypeLabel = function (type) {
                if (type === 'google') return $scope.translate('Gmail / Google Workspace (individual sign-in)');
                if (type === 'google_workspace') return $scope.translate('Google Workspace (Admin)');
                return $scope.translate('Generic IMAP / SMTP');
            };

            if (!Array.isArray($scope.providers)) {
                $scope.providers = [];
            }

            $scope.$watchCollection('providers', function (newValue) {
                if (!Array.isArray(newValue)) {
                    $scope.providers = [];
                }
            });

            $scope.openProvider = function (provider) {
                $scope.onOpen({ provider });
            };

            // Opens a confirmation dialog to delete a provider. On confirm, calls
            // the API and removes the provider from the list.
            $scope.showDeleteProviderPopup = function (provider) {
                const tableScope = $scope;

                GhDialog.show({
                    position: 'center',
                    toolbar: false,
                    template: {
                        toolbar: '',
                        resizable: false,
                        content: `
                            <div class="delete_email_provider-popup">
                                <div class="dialog-share-group">
                                    <span gh-icon="rubbish FF0D0D 65px"></span>
                                    <p class="dialog-share-group__title">{{translate('Deleting Provider!')}}</p>
                                </div>

                                <div class="dialog-share-group__content">
                                    <p class="info">
                                        {{translate('Do you really want to delete this email provider? Accounts linked under it will stop syncing.')}}
                                    </p>

                                    <div class="dialog-share-group__content__buttons">
                                        <button
                                            class="dialog-share-group__content__buttons__add btn btn-blue-reverse"
                                            ng-click="deleteProvider()"
                                            ng-disabled="deleting"
                                        >
                                            {{deleting ? translate('Deleting...') : translate('Delete')}}
                                        </button>

                                        <button
                                            class="dialog-share-group__content__buttons__cancel btn btn-blue"
                                            ng-click="cancel()"
                                        >
                                            {{translate('Cancel')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        `
                    },
                    locals: {
                        provider
                    },
                    controller: [
                        '$scope',
                        'provider',
                        'localizationService',
                        function ($scope, provider, localizationService) {
                            const dictionary = localizationService.getDictionary('account_settings');
                            $scope.translate = (word) => localizationService.translate(word, dictionary);
                            $scope.deleting = false;

                            $scope.deleteProvider = async function () {
                                $scope.deleting = true;
                                try {
                                    await EmailSettingsService.deleteProvider(provider.provider_id);

                                    if (!Array.isArray(tableScope.providers)) {
                                        tableScope.providers = [];
                                    }

                                    const index = tableScope.providers.findIndex(function (p) {
                                        return p.provider_id === provider.provider_id;
                                    });

                                    if (index !== -1) {
                                        tableScope.providers.splice(index, 1);
                                    }

                                    tableScope.$applyAsync();
                                    $scope.cancel();
                                } catch (error) {
                                    console.log('Provider delete error:', error);
                                    $scope.deleting = false;
                                    $scope.$applyAsync();
                                }
                            };
                        }
                    ]
                });
            };
        }],

        template: `
            <div class="listing_table">
                <div class="listing_table_head_wrapper">
                    <div class="listing_table_column bottom_line w-45">
                        <div class="tab">{{translate('Name')}}</div>
                    </div>

                    <div class="listing_table_column w-25">
                        <div class="tab">{{translate('Type')}}</div>
                    </div>

                    <div class="listing_table_column w-20">
                        <div class="tab">{{translate('Status')}}</div>
                    </div>

                    <div class="listing_table_column w-10"></div>
                </div>

                <div class="listing_table_body_wrapper">
                    <div
                        class="listing_table_row"
                        ng-click="openProvider(provider)"
                        ng-repeat="provider in providers track by provider.provider_id"
                    >
                        <div class="listing_table_column w-45">
                            <span class="number">{{$index + 1}}</span>
                            <div class="name">{{provider.name}}</div>
                        </div>

                        <div class="listing_table_column w-25">
                            {{providerTypeLabel(provider.type)}}
                        </div>

                        <div class="listing_table_column w-20">
                            <span
                                class="status-badge"
                                ng-class="provider.enabled ? 'running' : 'stopped'"
                            >
                                {{provider.enabled ? translate('Enabled') : translate('Disabled')}}
                            </span>
                        </div>

                        <div class="listing_table_column w-10">
                            <span
                                ng-click="showDeleteProviderPopup(provider); $event.stopPropagation()"
                                class="delete_icon"
                                gh-icon="rubbish 0d99ff 20px"
                            ></span>
                        </div>
                    </div>

                    <div ng-if="!providers.length" class="listing_table_nodata">
                        <p>{{translate('No email providers configured yet')}}</p>
                    </div>
                </div>
            </div>
        `
    };
}]);
